<script setup lang="ts">
import Tabs from "~/components/ui/Tabs.vue";
import FixedOdds from "~/components/layout/TrackRacing/FixedOdds/FixedOdds.vue";
import Jackpot from "~/components/layout/TrackRacing/Jackpot/Jackpot.vue";
import { useSettings } from "~/store/settings";
import t from "~/utils/translate";

const router = useRouter();
const settings = useSettings();

const route = useRoute();
const tab = ref<string>("fixed-odds");

const sportId = computed(() => {
	return route.params.sportId as string;
});

const selectedModule = computed(() => {
	return route.params.fixtureType;
});

const racingTabs = computed(() => {
	const tabs = [
		{
			name: t("fixed-odds"),
			value: "fixed-odds",
			isVisible: true,
		},
		{
			name: t("jackpot"),
			value: "jackpot",
			isVisible: settings.hasFeature("HorseRacingJackpotEnabled") && sportId.value === "horse-racing",
		},
		{
			name: t("tote"),
			value: "tote",
			isVisible: sportId.value === "horse-racing" && settings.getCountryConfig?.countryIsoTwo === "ZA",
		},
	];
	return tabs.filter((t) => t.isVisible);
});

onMounted(() => {
	if (selectedModule.value) {
		tab.value = selectedModule.value.toString();
	}
});

const handleTabNavigation = (selectedTab: string) => {
	if (selectedTab === "tote") {
		router.push({ path: "/tote/horseracing" });
	} else {
		tab.value = selectedTab;
		const fixtureType = selectedTab === "fixed-odds" ? "" : `/${selectedTab}`;
		router.push({ path: `/sport/${sportId.value}${fixtureType}` });
	}
};
</script>
<template>
	<div class="w-full">
		<div v-if="racingTabs.length > 1" class="flex items-center justify-center w-full p-2 mb-2 bg-light-50 dark:bg-dark-800">
			<div class="w-[320px]">
				<Tabs @on-update="(val) => handleTabNavigation(val)" :active="tab" :tabs="racingTabs" tab-class="flex-1 justify-center" />
			</div>
		</div>
		<FixedOdds :sportId="sportId" v-if="tab === 'fixed-odds'" />
		<Jackpot v-if="tab === 'jackpot'" />
	</div>
</template>
